import React from 'react';

const RoleReadOnlyPage = ({ title, description }) => {
  return (
    <div className="max-w-5xl mx-auto">
      <div className="rounded-3xl border bg-white p-6 shadow-sm" style={{ borderColor: '#f2d8e0' }}>
        <h1 className="text-2xl font-bold text-slate-900">{title}</h1>
        <p className="text-sm text-slate-500 mt-2">{description}</p>
      </div>
    </div>
  );
};

export default RoleReadOnlyPage;
